import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import paymentMethodsServices from '@src/services/paymentMethods.services';

export const getList = createAsyncThunk('admin/getList', async (body, { rejectWithValue }) => {
  try {
    return await paymentMethodsServices.getList();
  } catch (error) {
    return rejectWithValue(error?.data);
  }
});

const initialState = {
  paymentMethodList: [],
};

export const paymentMethodsSlice = createSlice({
  name: 'admin/paymentMethods',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getList.fulfilled, (state, action) => {
      state.paymentMethodList = action?.payload?.data;
    });
  },
});
